import type React from "react";

import { faCog } from "@fortawesome/pro-regular-svg-icons";
import { faCircleExclamation, faLayerGroup } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MUITabs } from "shared/atoms/MUI";
import { RED } from "theme/colors";

import type { FormErrorSections, PanelTab } from "./types";

export interface PanelTabsProps {
  children?: React.ReactNode;
  formErrorSections: FormErrorSections;
  panelTab: PanelTab;
  setPanelTab: React.Dispatch<React.SetStateAction<PanelTab>>;
}

export const PanelTabs: React.FC<PanelTabsProps> = ({ formErrorSections, panelTab, setPanelTab }) => {
  const { t } = useTranslation();
  const errorInLibrary = formErrorSections.library;
  const errorInSettings = formErrorSections.settings;

  return (
    <MUITabs
      value={panelTab}
      onChange={(_event, newValue) => {
        setPanelTab(newValue);
      }}
      variant="fullWidth"
      sx={{ paddingTop: "15px" }}
    >
      <Tab
        value="library"
        label={
          <Box sx={{ position: "relative", ...(errorInLibrary && { color: RED[100] }) }}>
            {t("treatment_editor.panels.activity_library")}
            {errorInLibrary && (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                color={RED[100]}
                style={{ position: "absolute", top: "-4px", right: "-16px" }}
              />
            )}
          </Box>
        }
        icon={
          <FontAwesomeIcon icon={faLayerGroup} fontSize="16px" style={{ ...(errorInLibrary && { color: RED[100] }) }} />
        }
        iconPosition="start"
      />
      <Tab
        value="settings"
        label={
          <Box sx={{ position: "relative", ...(errorInSettings && { color: RED[100] }) }}>
            {t("treatment_editor.panels.settings")}
            {errorInSettings && (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                color={RED[100]}
                style={{ position: "absolute", top: "-4px", right: "-16px" }}
              />
            )}
          </Box>
        }
        icon={<FontAwesomeIcon icon={faCog} fontSize="16px" style={{ ...(errorInSettings && { color: RED[100] }) }} />}
        iconPosition="start"
      />
    </MUITabs>
  );
};
